import nextWork from '../../utils/net'
import {
  JudgeQrCodeEffectiveData,
  SubmitScanInfoData,
  QueryPublishAreaAndChannelTypeData,
  QueryRetailerByAreaData,
} from './type'

import { DOMAIN } from '../url'

const API_SIGN_IN = '/api/proretail/intl/qr/app'


// 判断二维码是否有效
export const judgeQrCodeEffective = (data: JudgeQrCodeEffectiveData) => {
  return nextWork.post(`${DOMAIN}${API_SIGN_IN}/judgeQrCodeEffective`, data, false)
}

// 提交扫码信息
export const submitScanInfo = (data: SubmitScanInfoData, dnsName: string) => {
  return nextWork.post(`${dnsName ? dnsName : DOMAIN}${API_SIGN_IN}/submitScanInfo`, data, false)
}

// 查询发布区域和渠道类型
export const queryPublishAreaAndChannelType = (data: QueryPublishAreaAndChannelTypeData) => {
  return nextWork.post(`${DOMAIN}${API_SIGN_IN}/queryPublishAreaAndChannelType`, data, false)
}

// 查询经销商区域
export const queryRetailerByArea = (data: QueryRetailerByAreaData, dnsName: string) => {
  return nextWork.post(`${dnsName ? dnsName : DOMAIN}${API_SIGN_IN}/queryRetailerByArea`, data, false)
}